/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Noreviews2Inputs */

const id_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada ulasan`)
};

const ms_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada ulasan`)
};

const da_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen anmeldelser endnu`)
};

const de_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Bewertungen`)
};

const en_us2_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No reviews yet`)
};

const es_es2_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay reseñas`)
};

const es_mx2_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay reseñas`)
};

const fil_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang review`)
};

const fr_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun avis pour le moment`)
};

const it_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna recensione`)
};

const hu_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Még nincsenek értékelések`)
};

const nl_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen reviews`)
};

const no_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen omtaler ennå`)
};

const pl_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak recenzji`)
};

const pt_br2_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há avaliações`)
};

const pt_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda sem avaliações`)
};

const ro_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Încă nu există recenzii`)
};

const fi_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä arvosteluja`)
};

const sv_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga recensioner än`)
};

const vi_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có đánh giá`)
};

const tr_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz yorum yok`)
};

const cs_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné recenze`)
};

const bg_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все още няма ревюта`)
};

const ru_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет обзоров`)
};

const uk_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відгуків ще немає`)
};

const ar_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد مراجعات بعد`)
};

const hi_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक कोई समीक्षा नहीं`)
};

const th_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีรีวิว`)
};

const ja_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだレビューはありません`)
};

const zh_cn2_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无评论`)
};

const zh_hant1_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暫無評論`)
};

const ko_offerdetail_reviews_noreviews2 = /** @type {(inputs: Offerdetail_Reviews_Noreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 리뷰가 없습니다`)
};

/**
* | output |
* | --- |
* | "No reviews yet" |
*
* @param {Offerdetail_Reviews_Noreviews2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_noreviews2 = /** @type {((inputs?: Offerdetail_Reviews_Noreviews2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Noreviews2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_noreviews2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_noreviews2(inputs)
	if (locale === "da") return da_offerdetail_reviews_noreviews2(inputs)
	if (locale === "de") return de_offerdetail_reviews_noreviews2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_noreviews2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_noreviews2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_noreviews2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_noreviews2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_noreviews2(inputs)
	if (locale === "it") return it_offerdetail_reviews_noreviews2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_noreviews2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_noreviews2(inputs)
	if (locale === "no") return no_offerdetail_reviews_noreviews2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_noreviews2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_noreviews2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_noreviews2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_noreviews2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_noreviews2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_noreviews2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_noreviews2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_noreviews2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_noreviews2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_noreviews2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_noreviews2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_noreviews2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_noreviews2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_noreviews2(inputs)
	if (locale === "th") return th_offerdetail_reviews_noreviews2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_noreviews2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_noreviews2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_noreviews2(inputs)
	return ko_offerdetail_reviews_noreviews2(inputs)
});
export { offerdetail_reviews_noreviews2 as "offerDetail.reviews.noReviews" }